<template>
  <div class="pk-page-wrapper">
    <div class="pk-page-spacing-flex"></div>
    <div class="pk-subset__page">
      <div class="pk-subset__head">
        <div class="__left-part">
          <div class="pk-subset__head-select">
            <router-link :to="{path:'/ce/' + (currentCE ? (currentCE.doc._id + '/matrix') : '')}">
              <img src="../../assets/icons/criticaledition_matrix.svg"
               style="height:30px;margin-right:5px">
            </router-link>
            <div class="pk-label pk-flex">
              <div class="pk-flex__00auto"
               style="margin-right:20px">
                selected sub-set
              </div>
              <select class="pk-flex__1"
               v-model="selectedComparison">
                <option v-for="(cp,i) in comparisons" :key="i"
                 :value="i">{{cp._source['132_cptitle']}}</option>
              </select>
            </div>
          </div>
          <div class="pk-subset__matrix">
            <div class="pk-flex__00auto">
              <div v-for="(ss,si) of filterSlidesets" :key="si"
                class="pk-subset__matrix-row"
              >
                <!-- <div 
                  @click="showAll = !showAll"
                  :class="showAll ? '' : 'pk-hide-arrow'"
                >
                  <span :style="si > 0 ? 'visibility:hidden' : ''"
                    style="cursor: pointer; height:100%;margin-right:5px"
                    :class="'fa-2x fas fa-caret-down'"></span>
                </div>
                <div 
                  @click="showAll = !showAll"
                  :class="!showAll ? '' : 'pk-hide-arrow'"
                >
                  <span :style="si > 0 ? 'visibility:hidden' : ''"
                    style="cursor: pointer; height:100%;margin-right:5px"
                    :class="'fa-2x fas fa-caret-right'"></span>
                </div> -->
                <div class="__matrix-slideset-title">{{ss.doc._source['54_sssigle']}}</div>
              </div>
            </div>
            <div class="">
              <div v-for="(ss,ssi) of filterSlidesets" :key="ssi"
               class="pk-subset__matrix-row"
              >
                <div v-for="(slide,si) of ss.slides"
                 :key="'sl'+si">
                  <div class="__matrix-slide"
                   :style="getSlideStyle(slide,ssi)">
                    <div>
                      {{si+1}}
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
        <div class="__right-part">

        </div>
      </div>
      <div class="pk-subset__main-wrapper">
        <div class="pk-subset__main">
          <div class="pk-subset__comparison_wrapper">
            <div class="pk-subset__comparison_box"
             v-for="(cd,ci) of comparisonData" :key="ci">
              <div class="__head">
                <router-link class="pk-flex__00auto"
                 :to="{path:cd.path}">
                   <img style="height:25px;width: 25px" :src="getImg('archiveedition.svg')">
                  <!-- <div style="height:25px;width: 25px; font-size: 14px;padding:1px;"
                   class="pk-flex-all-center"
                   :style="cd.linkStyle"><span style="font-weight: 500;">AE</span></div> -->
                </router-link>
                <div class="pk-flex__1 pk-flex__vh-center"
                 :style="cd.titleStyle">{{cd.title}}</div>
                <div class="pk-flex__00auto __matrix-slide"
                 :style="cd.indexStyle" 
                 :title="cd.type === 'related item' ? cd.type : ''">
                  {{cd.slideIndex || cd.slideIndex === 0 ? cd.slideIndex + 1 : 'RI'}}
                </div>
              </div>
              <div class="__body">
                <div class="__image-wrapper">
                  <img :src="cd.image" />
                </div>
              </div>
              <div class="__footer">
                <div v-if="ci === 0"
                 class="pk-flex__vh-center"
                 @click="showCompareModal"
                 style="padding-left:10px;padding-right:10px; border-radius:2px;cursor:pointer; border:2px solid #ddd">
                  compare
                </div>
                <div class="pk-flex"></div>
                <div class="__checkbox"
                 @click="selectBox(cd)">{{cd.selected}}
                  <input v-if="compareItems.indexOf(cd) > -1"
                   type="radio"
                   checked="checked">
                </div>
              </div>
            </div>
          </div>
          <div v-if="expand_commentary"
           class="__right-part"></div>
        </div>
      </div>
    </div>
    <div class="pk-page-spacing-flex"></div>
    <div class="pk-right--overlay"
     style="overflow: auto;padding: 25px 25px 25px 0px;"
     :style="expand_commentary ? 'z-index: 100;' : ''">
      <div class="pk-flex pk-commentary-title">
        <div class="pk-flex__00auto pk-flex__vh-center">
          <img :src="getImg('commentary.svg')" />
        </div>
        <div class="pk-flex__1 pk-flex__vh-center">
          <a v-b-toggle="'pk-subset__commentary'"
           @click="expand_commentary = !expand_commentary"
           :class="expand_commentary ? '' : 'pk-hide-arrow'"
           style="cursor: pointer;">
            <span :class="'fa-lg fas fa-caret-down'"></span> Commentary
          </a>
          <a v-b-toggle="'pk-subset__commentary'"
           @click="expand_commentary = !expand_commentary"
           :class="!expand_commentary ? '' : 'pk-hide-arrow'"
           style="cursor: pointer;">
            <span :class="'fa-lg fas fa-caret-right'"></span> Commentary
          </a>
        </div>
      </div>

      <b-collapse class="collapse pk-subset__commentary-body"
       id="pk-subset__commentary" v-html="commentaryData">
      </b-collapse>
    </div>

    <modal name="pk-subset__compare-modal"
     style="background-color:rgba(0,0,0,0.65)"
     :width="'80%'"
     :height="'80%'"
     :minWidth="1200"
     :clickToClose="false"
     :minHeight="600">
      <div class="pk-subset__compare-wrapper">
        <div class="__left"
         v-if="compareItems && compareItems[0]">
          <div class="__title">{{compareItems[0].title}}</div>
          <div class="__body">
            <div class="__image-wrapper">
              <div class="__image">
                <deepzoom-view :inputData="getCopmareItemDZ(compareItems[0])"></deepzoom-view>
              </div>
            </div>

          </div>
          <div class="__footer">
            <div v-if="compareItems && compareItems.length === 1"
             style="cursor:pointer"
             @click="hideCompareModal">close X</div>
          </div>
        </div>
        <div v-if="compareItems && compareItems.length === 2"
         class="__separator"></div>
        <div class="__right"
         v-if="compareItems && compareItems[1]">
          <div class="__title">{{compareItems[1].title}}</div>
          <div class="__body">
            <div class="__image-wrapper">
              <div class="__image">
                <deepzoom-view :inputData="getCopmareItemDZ(compareItems[1])"></deepzoom-view>
              </div>
            </div>
          </div>
          <div class="__footer">
            <div style="cursor:pointer"
             @click="hideCompareModal">close X</div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import DeepzoomView from '../../components/DeepzoomView';
import Vue from 'vue';
import { FudapiService } from '../../utils/fudapi.service';
import Util from '../../utils/util';

export default Vue.extend({
  components: {
    'deepzoom-view': DeepzoomView
  },

  data() {
    return {
      startLoad: {
        deepestReached: false,
        threads: []
      },
      expand_commentary: false,
      selectedComparison: 0,
      compareItems: [],
      showAll: true,
      slidesetColors: [
        '0,108,120',
        '0,101,157',
        '0,115,46',
        '111,173,212',
        '200,11,160',
        '160,110,39',
      ]
    };
  },
  watch: {
    selectedComparison(cpid) {
      const cp = this.currentComparison;
      if (!cp) {
        return;
      }
      this.compareItems = [];

      const query = {
        cpid: cp._id
      };

      this.$router.push({
        params: query
      });
    },
    currentComparison() {
      Util.checkStartLoad({
        loadingCount: 0,
        startLoad: this.startLoad,
        retryCondition: () => { 
          return !this.currentComparison;
        },
        allDoneCallback: () => {
          const doc = this.currentComparison;
          const oriContent = doc._source['132_cpcomment'];
          const obj = {
            str: oriContent
          };
          this.startLoad.threads.push(FudapiService.transformFreetext(obj).subscribe(
            () => null,
            err => {
              console.log(err);
            },
            () => {
              doc._source['132_cpcomment'] = obj.str;
            }
          ));
        }
      });
    }
  },
  created() {
    this.fetchData();
  },
  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('Critical Edition Subset');
    }
    Util.checkStartLoad({
      loadingCount: 0,
      startLoad: this.startLoad,
      retryCondition: () => { 
        return !this.currentComparison;
      },
      allDoneCallback: () => {
        const obj = {str: this.currentComparison._source['132_cpcomment']};
        this.startLoad.threads.push(FudapiService.transformFreetext(obj).subscribe(
          () => null,
          err => {
            console.log(err);
          },
          () => {
            this.currentComparison._source['132_cpcomment'] = obj.str;
          }
        ));
      }
    });
  },
  destroyed() {
    for (const subscriber of this.startLoad.threads) {
      subscriber.unsubscribe();
    }
  },
  computed: {
    criticalEditions() {
      return this.$store.state.criticalEditions;
    },
    currentCE() {
      if (this.criticalEditions) {
        const id = this.ceid;
        return this.criticalEditions.find(a => a.doc._id === id);
      }
      return;
    },
    ceid() {
      return this.$route.params.ceid;
    },

    slidesets() {
      if (!this.currentCE) {
        return;
      }
      this.currentCE.slidesets.sort((a, b) => {
        if (b.doc._source['54_sssigle'].indexOf('@nominal') > -1) {
          return 1;
        } else {
          return 0;
        }
      });
      return this.currentCE.slidesets;
    },
    filterSlidesets() {
      return this.slidesets;
      // if (this.showAll) {
      // }
      // const comparisonData = this.comparisonData;
      // const sigle = [];
      // if (comparisonData) {
      //   comparisonData.forEach(c => {
      //     console.log(c.title);
      //     sigle.push(c.title);
      //   });
      // }

      // return this.slidesets
      //   ? this.slidesets.filter(ss => {
      //       return sigle.indexOf(ss.doc._source['54_sssigle']) > -1;
      //     })
      //   : null;
    },

    comparisons() {
      if (this.currentCE) {
        const cpid = this.$route.params.cpid;
        const cps = this.currentCE.comparisons;
        const curr = cps.find(c => c._id === cpid);
        if (curr) {
          this.selectedComparison = cps.indexOf(curr);
        }
        return cps;
      }
    },

    currentComparison() {
      if (this.comparisons) {
        return this.comparisons[this.selectedComparison];
      }
    },
    commentaryData() {
      if (this.currentComparison) {
        return this.currentComparison._source['132_cpcomment'];
      }
    },

    comparisonData() {
      const slidesets = this.slidesets;
      const comparison = this.currentComparison;
      if (!slidesets || !comparison) {
        return;
      }

      const ssColors = this.slidesetColors;

      const out = [];
      // console.log(slidesets);
      // console.log(ssColors);
      slidesets.forEach((ss, i) => {
        comparison._source['132_Items'].forEach(item => {
          const cpItemId = item.cpmasitem;
          const order = parseInt(item.cpmasitemorder, 10);
          const imageName = item.cpmasitemimgname;
          ss.slides.forEach((sl, j) => {
            let image = sl.$_screenImage ? sl.$_screenImage.dbImageInfo['thumbnail'] : '';
            let imageForModal = sl.$_screenImage ? sl.$_screenImage : null;
            if (imageName) {
              for (const img of sl.$_images) {
                if (imageName === img.sourcename) {
                  image = img.dbImageInfo['thumbnail'];
                  imageForModal = img;
                  break;
                }
              }
            }
            if (sl._id === cpItemId) {
              out.push({
                ss: ss,
                type: 'slide',
                order: order,
                linkStyle: '',
                titleStyle: 'background-color: rgba(' + ssColors[i] + ',1); color: rgb(238, 238, 238);',
                indexStyle: 'background-color: rgba(' + ssColors[i] + ',0.8)',
                slideIndex: j,
                path: '/ae/' + ss._id + '?view=s-objectview',
                slide: sl,
                title: ss.doc._source['54_sssigle'],
                image: image,
                imageForModal: imageForModal,
              });
            }
          });
          ss.relatedItems.forEach((ri, j) => {
            let image = ri.$_images[0] ? ri.$_images[0].dbImageInfo['thumbnail'] : '';
            let imageForModal = ri.$_images[0] ? ri.$_images[0] : null;
            if (imageName) {
              for (const img of ri.$_images) {
                if (imageName === img.sourcename) {
                  image = img.dbImageInfo['thumbnail'];
                  imageForModal = img;
                  break;
                }
              }
            }
            if (ri._id === cpItemId) {
              out.push({
                ss: ss,
                type: 'related item',
                order: order,
                linkStyle: '',
                titleStyle: 'background-color: rgba(' + ssColors[i] + ',1); color: rgb(238, 238, 238);',
                indexStyle: 'background-color: rgba(' + ssColors[i] + ',0.8)',
                path: '/ae/' + ss._id + '?view=ss-relateditems',
                relatedItem: ri,
                title: ss.doc._source['54_sssigle'],
                image: image,
                imageForModal: imageForModal,
              });
            }
          });
        });
      });
      out.sort((a, b) => {
        return a.order - b.order;
      });
      return out;
    }
  },

  methods: {
    fetchData() {
      this.$store.dispatch('fetchCriticalEdition', {
        idArr: [this.ceid], 
        startLoad: this.startLoad, 
        cb: undefined
      });
    },
    getImg(name) {
      return this.$getIcon(name);
    },
    isNominalVersion(ss) {
      let ret = false;
      if (!this.showAll 
        && ss.doc._source['54_sssigle'] 
        && ss.doc._source['54_sssigle'].indexOf('@nominal') > 0) {
        ret = true;
      }
      return ret;
    },

    getSlideStyle(slide, i) {
      if (!this.currentComparison) {
        return '';
      }

      const c = this.currentComparison._source['132_Items'].find(
        item => item.cpmasitem === slide._id
      );

      if (c) {
        return 'background-color: rgba(' + this.slidesetColors[i] + ',1)';
      }
      return '';
    },
    selectBox(cd) {
      const idx = this.compareItems.indexOf(cd);
      if (idx >= 0) {
        this.compareItems.splice(idx, 1);
      } else if (this.compareItems.length < 2) {
        this.compareItems.push(cd);
      }
    },
    getCopmareItemDZ(compareItem) {
      return compareItem.imageForModal;
    },
    // slideInComparisonGroup(slide) {
    //   if (!this.comparisons) {
    //     return false;
    //   }
    //   let _id = slide._id;
    //   let groupIdx = 0;
    //   let out = [2, 3, 4];
    //   this.comparisons.forEach(cp => {
    //     let c = cp._source['132_Items'].find(item => item.cpmasitem == _id);
    //     if (c) {
    //       out.push(groupIdx);
    //     }
    //     groupIdx++;
    //   });
    //   return out;
    // },
    showCompareModal() {
      if (!this.compareItems || this.compareItems.length < 1) {
        return;
      }
      this.$modal.show('pk-subset__compare-modal');
    },
    hideCompareModal() {
      this.$modal.hide('pk-subset__compare-modal');
    }
  }
});
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variable.scss';
@import '../../assets/scss/layout.scss';
@import '../../assets/scss/color.scss';
@import '../../assets/scss/size.scss';


.pk-page-wrapper {
  @extend .pk-flex__1;
  @extend .pk-flex;
}

.pk-subset__page {
  @extend .pk-flex__1;
  @extend .pk-flex--column;
}

.pk-subset__head {
  margin-top: 30px;
  @extend .pk-flex__00auto;
  justify-content: space-between;
}

.__left-part {
  @extend .pk-flex__1;
}

.__right-part {
  @extend .pk-flex__00auto;
  width: 20%;
}

.pk-label {
  background-color: #d8dff2;
  padding: 5px;
  height: 30px;
}

.pk-subset__head-select {
  @extend .pk-flex;
  margin-bottom: 10px;
}

.pk-subset__matrix {
  @extend .pk-flex;
}

.pk-subset__matrix-row {
  @extend .pk-flex__00auto;
  @extend .pk-flex;
  padding: 5px 0px;
  height: 35px;
  .__matrix-slideset-title {
    @extend .pk-flex;
    @extend .pk-flex__1;
    align-items: center;
    margin-left: 5px;
    margin-right: 5px;
    padding: 0px 10px;
    background-color: rgb(229, 229, 229);
  }
  .__matrix-slide {
    @extend .pk-flex__vh-center;
    width: 25px;
    height: 100%;
    margin-right: 2px;
    background-color: rgb(157, 156, 161);
    color: #fff;
    border-radius: 2px;
  }
}

.pk-subset__main-wrapper {
  @extend .pk-flex__1;
  @extend .pk-flex;
  position: relative;
}

.pk-subset__main {
  position: absolute;
  z-index: 20;
  width: 100%;
  height: 100%;
  @extend .pk-flex;
  .pk-subset__comparison_wrapper {
    @extend .pk-flex__1;
    @extend .pk-flex;
    padding: 10px 0;
    flex-wrap: wrap;
    overflow: auto;
    .pk-subset__comparison_box {
      @extend .pk-flex--column;
      width: 250px;
      margin: 10px 10px 10px 0;
      height: 250px;
      position: relative;
      .__head {
        @extend .pk-flex;
        @extend .pk-flex__00auto;
        height: 25px;
        border-radius: 4px;
      }
      .__body {
        @extend .pk-flex__1;
        margin-top: 2px;
        position: relative;
        .__image-wrapper {
          @extend .pk-flex__vh-center;
          background-color: #eee;
          position: absolute;
          width: 100%;
          height: 100%;
          img {
            max-height: 100%;
            max-width: 100%;
          }
        }
      }
      .__footer {
        @extend .pk-flex__00auto;
        @extend .pk-flex;
        justify-content: space-between;
        margin-top: 5px;
        height: 30px;
        .__checkbox {
          @extend .pk-flex__vh-center;
          width: 30px;
          height: 100%;
          border: 2px solid #ddd;
          border-radius: 2px;
          cursor: pointer;
          input {
            margin: 0px;
            padding: 0px;
          }
        }
      }
    }
  }
  .__matrix-slide {
    @extend .pk-flex__vh-center;
    width: 25px;
    height: 100%;
    background-color: rgb(157, 156, 161);
    color: #fff;
    border-radius: 2px;
  }
}

.pk-subset__compare-wrapper {
  @extend .pk-flex;
  height: 100%;
  background-color: rgb(156, 155, 160);
  .__separator {
    width: 10px;
    height: 100%;
    background-color: rgb(113, 112, 117);
  }
  .__title {
    @extend .pk-flex__vh-center;
    color: #fff;
    height: 45px;
  }
  .__left {
    @extend .pk-flex__1;
    @extend .pk-flex--column;
  }
  .__right {
    @extend .pk-flex__1;
    @extend .pk-flex--column;
  }
  .__body {
    @extend .pk-flex__1;
    @extend .pk-flex;
    padding: 0 30px;
    .__image-wrapper {
      @extend .pk-flex__1;
      position: relative;
      .__image {
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: #eee;
      }
    }
  }
  .__footer {
    @extend .pk-flex__00auto;
    @extend .pk-flex;
    flex-direction: row-reverse;
    -ms-flex-direction: row-reverse;
    -webkit-flex-direction: row-reverse;
    height: 45px;
    color: #fff;
    padding: 20px 10px;
  }
}

.pk-commentary-title {
  background-color: $navItemColor;
  line-height: 25px;
  height: 25px;
  img {
    height: 25px;
    margin-bottom: 1px;
    background-color: #fff;
  }
  * {
    color: #fff;
  }
}

.pk-subset__commentary-body {
  border: 2px solid rgb(197, 197, 197);
  padding: 10px;
}

.tst {
  color: rgb(0, 108, 120);
  color: rgb(0, 101, 157);
  color: rgb(0, 115, 46);
  color: rgb(111, 173, 212);
  color: rgb(7, 97, 160);
  color: rgb(0, 110, 39);
}
</style>